import { Activity, BellRing, ClipboardCheck, Zap } from 'lucide-react';
import type { ReactNode } from 'react';

const FEATURES = [
  { icon: ClipboardCheck, text: 'Async daily check-ins — no stand-up required' },
  { icon: BellRing,       text: 'T-3 and T-1 escalation alerts before tasks slip' },
  { icon: Activity,       text: 'Overwork detection across your whole team' },
];

export default function AuthShell({ children }: { children: ReactNode }) {
  return (
    <main className="flex min-h-screen">
      {/* Brand panel — desktop only */}
      <div
        className="hidden md:flex md:w-[360px] shrink-0 flex-col justify-between p-10"
        style={{ background: 'linear-gradient(150deg, hsl(var(--primary)) 0%, hsl(262, 80%, 28%) 100%)' }}
      >
        <div className="flex items-center gap-3">
          <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-white/20">
            <Zap className="h-5 w-5 text-white" />
          </div>
          <span className="text-lg font-bold text-white">Cadence</span>
        </div>

        <div>
          <p className="text-2xl font-bold leading-snug text-white">
            Engineering velocity<br />without the overhead.
          </p>
          <div className="mt-8 space-y-4">
            {FEATURES.map(({ icon: Icon, text }) => (
              <div key={text} className="flex items-start gap-3">
                <div className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-white/20">
                  <Icon className="h-3.5 w-3.5 text-white" />
                </div>
                <p className="text-sm text-white/80">{text}</p>
              </div>
            ))}
          </div>
        </div>

        <p className="text-xs text-white/30">R&amp;D Department Console</p>
      </div>

      {/* Form panel */}
      <div className="flex flex-1 flex-col items-center justify-center bg-muted/20 p-6 sm:p-10">
        {/* Mobile logo */}
        <div className="mb-8 flex flex-col items-center gap-2 md:hidden">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary">
            <Zap className="h-5 w-5 text-primary-foreground" />
          </div>
          <span className="text-xl font-bold tracking-tight">Cadence</span>
          <p className="text-sm text-muted-foreground">R&amp;D Department Console</p>
        </div>

        <div className="w-full max-w-sm">{children}</div>
      </div>
    </main>
  );
}
